import React from "react";
import { Link } from "react-router-dom";
import { shortLogo } from "../../config/config";
import { shareTextOf } from "../../utils/Universalfunctions";
import { Share } from "@mui/icons-material";

const BlogCard = ({ post }) => {

      return (
            <div className="col-md-4">
                  <div className="premium-card">
                        <div className="img-area">
                              <Link to={`/blog/${post?.slug}`} className="stretched-link">
                                    <img src={post?.image || shortLogo} alt={post?.title} className="card-img" />
                                    {/* <div className="tag">{post?.category}</div> */}
                              </Link>
                        </div>

                        <div className="details-area">
                              <div className="top-row">
                                    <span className="date">Update: {post?.date}</span> <br />

                                    <button type='button' className="copy-icon" onClick={() => shareTextOf(`${window.location.origin}/blog/${post?.slug}`)}> <Share />  </button>
                              </div>
                              <h3>{post?.title}</h3>
                              <p dangerouslySetInnerHTML={{ __html: post?.paragraph.slice(0, 200) }} />
                              <p>{post?.category}</p>
                              <Link to={`/blog/${post?.slug}`} className="link-arrow">Explore Full Blog ↗</Link>
                        </div>
                  </div>
            </div>
      );
};

export default BlogCard;